<template><a
    v-html="unitName"
    @click.prevent="click"
    @mouseover="$store.commit('hoverUnitId', uid)"
    @mouseout="$store.commit('hoverUnitId', null)"
    :style="unitStyle"
    v-show="is_uid_visible(uid)"
    :href="fullUrl"
  /></template>
<script>
import { debug, baseUrl } from '../globals'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'unit-button',
  props: ['uid'],
  computed: {
    ...mapState(['units']),
    ...mapGetters(['is_uid_visible']),
    unit() { return this.units[this.uid] },
    unitName() { return this.unit && this.unit.name || '' },
    unitStyle() {
      return this.unit && { background: this.$store.getters.unitStatus(this.unit).color } || {}
    },
    url() { return `/u/${this.uid}/s` },
    fullUrl() {
      return (
        debug
          ? `${baseUrl}#${this.url}`
          : baseUrl + this.url.substring(1)
      )
    },
  },
  methods: {
    click() {
      this.$router.push(this.url)
    },
  },
}
</script>
<style lang="scss" scoped>
a { text-decoration: none; }
</style>
